export const parsePhoneNumber = (p, c, codes) => {
  let code = c
  let phone = p
  if (p && p.charAt(0) === '+') {
    code = codes.find(cc => p.includes(cc))
    phone = code ? p.split(code)[1] : p
  }
  return { phone, code }
}
